import React from "react";
import { Image } from "@wss/image";
import { LazyLoadedGoogleModelViewer } from "@wss/model-viewer";
import { TransformComponent } from "react-zoom-pan-pinch";

interface ModelGalleryRendererProps {
  index: number;
  handleOverlayImageChange: (
    image: React.MouseEvent<HTMLAnchorElement>,
  ) => void;
  productDimensionsIsEnabled: boolean;
}

const ModelGalleryRenderer = ({
  index,
  handleOverlayImageChange,
  productDimensionsIsEnabled,
}: ModelGalleryRendererProps) => (
  <TransformComponent
    wrapperClass="hidden md:block"
    wrapperStyle={{
      overflow: "visible",
      width: "auto",
      height: "100%",
    }}
    contentStyle={{
      width: "auto",
      height: "100%",
      maxHeight: "100vh",
    }}
  >
    <a
      href={`#modal-model-${index}`}
      data-testid="3dmodel-thumbnail"
      className="
            border-gray-200
            border-solid
            border
            box-border
            h-20
            p-1
            no-underline
            w-20
            md:hover:outline
            hidden
            md:block
          "
      onClick={(e) => {
        LazyLoadedGoogleModelViewer.load();
        handleOverlayImageChange(e);
      }}
    >
      <Image
        width={1}
        height={1}
        className="w-full h-auto"
        src={
          productDimensionsIsEnabled
            ? "https://cdnimg.webstaurantstore.com/uploads/design/2025/2/3d-icon.svg"
            : "https://cdnimg.webstaurantstore.com/uploads/design/2018/9/ar-thumbnail.png"
        }
        alt="3D Viewer"
      />
    </a>
  </TransformComponent>
);

export default ModelGalleryRenderer;
